// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__12UEj","content":"styles_content__3lD68","checkbox":"styles_checkbox__1ZGgn","checkboxLabel":"styles_checkboxLabel__3NW09"};